import { useContext } from 'react'

import { CalendarBlankIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import { statuses } from '@/returns/constants'

import * as Styles from './styles'

const OrderItemDate = ({ language, completedAt, status }) => {
  const theme = useTheme()
  const { info } = useContext(AppContext)

  return (
    <Styles.MainContainer cancelled={status === statuses.cancelled}>
      <CalendarBlankIcon size={24} weight="light" />
      {completedAt && (
        <Text
          type="bodySRegular"
          color={status === statuses.cancelled ? theme.colors.text.subtle : theme.colors.text.default}
          customStyles={{
            textTransform: 'uppercase',
          }}
        >
          {new Intl.DateTimeFormat(language, { dateStyle: 'medium', timeZone: info?.selectedStore?.timezone }).format(
            new Date(completedAt)
          )}
        </Text>
      )}
    </Styles.MainContainer>
  )
}

export default OrderItemDate
